import { render } from "./NetworkEdit.vue?vue&type=template&id=1616d48e&ts=true"
import script from "./NetworkEdit.vue?vue&type=script&lang=ts"
export * from "./NetworkEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Windows/NetworkEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1616d48e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1616d48e', __exports__)) {
    api.reload('1616d48e', __exports__)
  }
  
  module.hot.accept("./NetworkEdit.vue?vue&type=template&id=1616d48e&ts=true", () => {
    api.rerender('1616d48e', render)
  })

}


export default __exports__